import React from 'react';
import {CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';

interface CatchByTime {
  year: number;
  month: number;
  totalCatches: number;
  taken: number;
  released: number;
  unknown: number;
}

export const CatchesByTimeChart = ({data}: { data: CatchByTime[] }) => {
  if (!data || data.length === 0) {
    return (
      <div className="card h-100">
        <div className="card-header">
          <h3 className="card-title">Fänge im Jahresverlauf</h3>
        </div>
        <div className="card-body">
          <div className="text-muted">Keine Daten verfügbar</div>
        </div>
      </div>
    );
  }

  const monthNames = [
    'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun',
    'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'
  ];

  const chartData = data.map(item => ({
    ...item,
    monthName: monthNames[item.month - 1]
  }));

  return (
    <div className="card h-100">
      <div className="card-header">
        <h3 className="card-title">Fänge im Jahresverlauf</h3>
      </div>
      <div className="card-body">
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="monthName" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="totalCatches"
              stroke="#3b82f6"
              strokeWidth={2}
              name="Gesamt"
            />
            <Line
              type="monotone"
              dataKey="taken"
              stroke="#ef4444"
              strokeWidth={2}
              name="Entnommen"
            />
            <Line
              type="monotone"
              dataKey="released"
              stroke="#10b981"
              strokeWidth={2}
              name="Zurückgesetzt"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
